import PropTypes from "prop-types"
import { LIST_ITEM_TEXT_OPTION, SEARCHABLE_MENU_ITEM, TABLE_GROUP_DROPDOWN } from "helpers/shapes"
import Table from "components/securities-table/table"
import AssetsTableHeader from "components/assets-table-header"

const IntradayAssetTable = ({
  aggregatedRow,
  columns,
  columnOrder,
  columnOrderOptions,
  count,
  dispatch,
  foundSecurities,
  groupDropdown,
  idSort,
  openFactorProfile,
  openSecurityProfile,
  openCompositeSecurity,
  page,
  setPage,
  setSort,
  status,
  setSelectedGroup,
  menuItems,
  metricType,
  metricTypeOptions,
  selectedView,
  setColumnOrder,
  setMetricType,
  setSelectedView,
  downloadData,
  downloadButtonTooltip,
  setSelectedSubView,
  subViewOptions,
  subView,
}) => <div className="modules_intraday-asset-table">
  <AssetsTableHeader
    {...{
      columnOrder,
      columnOrderOptions,
      menuItems,
      metricType,
      metricTypeOptions,
      selectedView,
      setColumnOrder,
      setMetricType,
      setSelectedView,
      downloadData,
      downloadButtonTooltip,
      selectedSubView: subView,
      setSelectedSubView,
      subViewOptions,
    }}
  />
  <Table
    {...{
      aggregatedRow,
      allowIdSort: true,
      columns,
      columnOrder,
      count,
      disableColumnsSelection: true,
      disableRowSelection: true,
      dispatch,
      foundSecurities,
      groupDropdown,
      idSort,
      openFactorProfile,
      openSecurityProfile,
      openCompositeSecurity,
      outsidePagination: true,
      page,
      rowIdClickOverride: (item) => setSelectedGroup(item.id),
      selectedSecurities: {},
      setPage,
      setSort,
      status,
    }}
  />
</div>

IntradayAssetTable.propTypes = {
  aggregatedRow: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  columnOrder: PropTypes.string.isRequired,
  columnOrderOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  count: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  foundSecurities: PropTypes.array.isRequired,
  groupDropdown: TABLE_GROUP_DROPDOWN,
  openFactorProfile: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  idSort: PropTypes.string,
  setSort: PropTypes.func.isRequired,
  status: PropTypes.string,
  setSelectedGroup: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(SEARCHABLE_MENU_ITEM),
  metricType: PropTypes.string,
  metricTypeOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  selectedView: PropTypes.string.isRequired,
  setColumnOrder: PropTypes.func.isRequired,
  setMetricType: PropTypes.func.isRequired,
  setSelectedView: PropTypes.func.isRequired,
  downloadData: PropTypes.object.isRequired,
  downloadButtonTooltip: PropTypes.string.isRequired,
  subView: PropTypes.string,
  setSelectedSubView: PropTypes.func.isRequired,
  subViewOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
}

export default IntradayAssetTable
